import { lazy } from 'react';

export const MSPSetupHub = lazy(() => import('@/workflows/tenant-setup/pages/SetupHubV2'));

export const ClientOnboardingHub = lazy(() =>
  import('@/workflows/tenant-setup/pages/ClientOnboardingHub').then((module) => ({
    default: module.ClientOnboardingHub,
  }))
);

export const PsaImportPage = lazy(() => import('@/workflows/tenant-setup/pages/PsaImportPage'));
